import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatDate, formatDateTime } from 'utils/Formatters';
import { find, isEmpty, map, groupBy } from 'lodash';

class AccountPlayersReportDetailsModal extends React.Component {
  render() {
    const {report} = this.props

    return (
      <div className='column u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>Report Details</b></h2>
        <hr className='u-margin-top--zero'/>
        <table className='o-table o-table--bordered'>
          <tbody>
            <tr>
              <th>Requested at</th>
              <td>{formatDateTime(report.createdAt)}</td>
            </tr>
            <tr>
              <th>Partners</th>
              <td>{this.renderRelated('partners')}</td>
            </tr>
            <tr>
              <th>Groups</th>
              <td>{this.renderRelated('groups')}</td>
            </tr>
            <tr>
              <th>Cohorts</th>
              <td>{this.renderCohorts()}</td>
            </tr>
            <tr>
              <th>Adults</th>
              <td>{this.renderRelated('accounts')}</td>
            </tr>
            <tr>
              <th>Include archived</th>
              <td>{report.params.archived ? 'Yes' : 'No'}</td>
            </tr>
            <tr>
              <th>Start date</th>
              <td>{formatDate(report.params.start)}</td>
            </tr>
            <tr>
              <th>End date</th>
              <td>{formatDate(report.params.end)}</td>
            </tr>
            <tr>
              <th>Query</th>
              <td>{report.params.q}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderRelated(related) {
    const collection = this.props[related]

    return this.relatedIds(related).map((id) => {
      return find(collection, p => p.value == id).label
    }).join(', ');
  }

  relatedIds(relatedAttribute) {
    const {report} = this.props

    if (isEmpty(report.params[relatedAttribute])) { return [] }

    return report.params[relatedAttribute].split(',').map((id) => {
      return parseInt(id, 10);
    })
  }

  renderCohorts() {
    return map(this.groupedReportCohorts(), (cohorts, groupName) => {
      return (
        <div key={groupName}>
          {
            [
              groupName,
              cohorts.map(c => c.name).join(", "),
            ].join(": ")
          }
        </div>
      )
    });
  }

  groupedReportCohorts() {
    return groupBy(this.reportCohorts(), 'group_name');
  }

  reportCohorts() {
    return this.relatedIds("cohorts").map((id) => {
      return find(this.cohorts(), p => p.id == id)
    });
  }

  cohorts() {
    return map(this.props.cohorts, (group, groupName) => { return group }).flat();
  }
}

const mapStateToProps = (state) => {
  return {
    partners: state.filters.partners,
    groups: state.filters.groups,
    cohorts: state.filters.cohorts,
    accounts: state.filters.accounts,
  }
}

AccountPlayersReportDetailsModal.propTypes = {
  report: PropTypes.object.isRequired,
  partners: PropTypes.arrayOf(PropTypes.object).isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  cohorts: PropTypes.object.isRequired,
  accounts: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default connect(mapStateToProps, null)(AccountPlayersReportDetailsModal)
